import React, { Component } from 'react';
import MobileBar from '../Site/MobileBar';
import ProductBinCheckDetail from './ProductBinCheckDetail';

import './style.css';

class ProductBinCheck extends Component {

  render() {
    return (
      <div>
        <MobileBar />
        <ProductBinCheckDetail />
      </div>    


    );
  }
}

export default ProductBinCheck;